import { useNavigate } from 'react-router-dom'

import { useAuthStore } from '../../../store/authStore'
import { useAllFundFilterStore } from '../../../store/filterSore/allFundStore'
import { useFundFilterStore } from '../../../store/filterSore/fundStore'
import Icons from '../icons'

const HeaderSearch = ({ hideIcon }: any) => {
  const { pageParams: allFundParams, setPageParams: setAllFundPageParams } =
    useAllFundFilterStore()
  const { pageParams, setPageParams } = useFundFilterStore()

  const navigate = useNavigate()
  const role = useAuthStore()?.userData?.role?.name
  const searchValue =
    role == 'indianadmin'
      ? allFundParams?.search ?? ''
      : pageParams?.search ?? ''

  const handleSearch = (key?: string) => {
    if (role == 'indianadmin') {
      setAllFundPageParams({
        ...allFundParams,
        search: key as string,
        page: 1,
      })

      navigate(`/funds-list`)
    } else if (role == 'user' || role == 'manager') {
      setPageParams({
        ...pageParams,
        search: key as string,
        page: 1,
      })
      if (role == 'user') {
        navigate(`/funds`)
      }
    }
  }

  return (
    <form
      className="w-full flex gap-2 md:gap-1 xl:gap-2 items-center relative header-search"
      action="#"
    >
      <input
        type="search"
        className="border border-divider py-1.5 md:py-1 px-2 xl:py-1.5 focus:outline-primary text-common md:text-[10px] xl:text-common rounded-sm xl:rounded-md outline-0 w-full md:w-[160px] xl:w-[200px]"
        placeholder="Search"
        value={searchValue}
        onChange={(e) => handleSearch(e.target.value)}
      />
      {!hideIcon && (
        <div className="size-8 shrink-0 md:size-6 xl:size-8  flex items-center justify-center text-white cursor-pointer rounded-sm xl:rounded-md bg-primary">
          <Icons className="text-white" name="search" />
        </div>
      )}
    </form>
  )
}

export default HeaderSearch
